import { render, staticRenderFns } from "./course-add-or-update.vue?vue&type=template&id=48ccf5e6&"
import script from "./course-add-or-update.vue?vue&type=script&lang=js&"
export * from "./course-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports